export default __webpack_public_path__ + "static/media/CNo.58-2.1a83e74b.jpg";